/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claim_Issue_Wrong_FolderInputs */

const en_claim_issue_wrong_folder = /** @type {(inputs: Claim_Issue_Wrong_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A file is not in the folder of the claims: add it again.`)
};

/**
* | output |
* | --- |
* | "A file is not in the folder of the claims: add it again." |
*
* @param {Claim_Issue_Wrong_FolderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const claim_issue_wrong_folder = /** @type {((inputs?: Claim_Issue_Wrong_FolderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_Issue_Wrong_FolderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_claim_issue_wrong_folder(inputs)
});